import { Box, Button, Chip, Typography, useTheme } from "@mui/material";
import React from "react";
import { InfoCardProps } from "./types";
import { StyledCard, StyledCardBody, StyledCardHeader } from "./styles";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import MobileFriendlyIcon from '@mui/icons-material/MobileFriendly';
import { SvgIcon } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { sentActionLog } from "../../utils/common";
import internetIcon from '../../assets/icons/internet.png'
import movilIcon from '../../assets/icons/movil.png'
import telefoniaIcon from '../../assets/icons/telefonia.png'
import videoIcon from '../../assets/icons/video.png'

const InfoCard: React.FC<InfoCardProps> = ({
  width,
  info,
  planName,
  competitors,
  zipCode = "",
  radioValue = "",
  hasMargin = false,
  hasSeeMore = false,
  isComplete = false,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleSeeMore = () => {
    sentActionLog('Info plan', `Click en 'ver mas' para la oferta ${info.id}`,undefined, undefined, info.id);
    navigate("/PlanInfo", {
      state: { plan: info, planName, zip: zipCode, competitors, radioValue },
    });
  };

  return (
    <StyledCard width={width} hasMargin={hasMargin} theme={theme}>
      <StyledCardHeader theme={theme}>
        <Box display="flex" gap="5px" alignItems="center">
          <Typography variant="body2" color="info">
            {info.play}
          </Typography>
          {(!info.paquetePrincipal.includes("izzi") && !info.paquetePrincipal.includes("Sky") && info.play !== "Móvil" ) && <img src={internetIcon} width={"20px"} height={"20px"} alt="internetIcon" />}
          {(!info.paquetePrincipal.includes("izzi") && !info.paquetePrincipal.includes("Sky") && info.play !== "Móvil" ) && <img src={telefoniaIcon} width={"15px"} height={"20px"} alt="telefoniaIcon" />}
          {(info.play === "Móvil" || info.paqueteMovil ) && <img src={movilIcon} width={"20px"} height={"20px"} alt="movilIcon" />}
          {(info.play.includes("3P") || info.paquetePrincipal.includes("izzi") || info.paquetePrincipal.includes("Sky")) && <img src={videoIcon} width={"20px"} height={"20px"} alt="videoIcon" />}
        </Box>
        <Box display={"flex"} flexDirection={"column"}>
          <Chip label={`${info.ac || '-'}`} color="info" size="small" />
          <Typography variant="body3" color="info" style={{marginTop: theme.spacing(.5)}}>
            Vigencia:{info.vigencia}
          </Typography>
        </Box>
      </StyledCardHeader>
      <StyledCardBody theme={theme}>
        <Box m={2} display="flex" alignItems="center" gap={1}>
          <SvgIcon
            htmlColor="#FF7B00"
            style={{ width: "45px", height: "45px" }}
          >
            <SignalCellularAltIcon style={{ width: "45px", height: "45px" }} />
          </SvgIcon>
          <Box style={{textWrap: "wrap"}}>
            <Typography variant="body2">{info.clasificacion}</Typography>
            <Typography variant="h6">
              {info.paquetePrincipal}
            </Typography>
            {info.paqueteOferta && <Typography variant="body2">
              {info.paqueteOferta} {info.duracionPaqueteOferta && `${info.duracionPaqueteOferta}`}
            </Typography>}
          </Box>
        </Box>
        { info.paqueteMovil && <Box m={2} display="flex" alignItems="center" gap={1}>
          <SvgIcon
            htmlColor="#FF7B00"
            style={{ width: "45px", height: "45px" }}
          >
            <MobileFriendlyIcon style={{ width: "45px", height: "45px" }} />
          </SvgIcon>
          <Box>
            <Typography variant="body2">Paquete Móvil</Typography>
            <Typography variant="h6">
              {info.paqueteMovil}
            </Typography>
            {info.paqueteOferta && <Typography variant="body2">
              {info.paqueteOferta} 6 meses
            </Typography>}
          </Box>
        </Box>}
        <Box ml={2} mr={2}>
          <Typography
            color={info.precioPromocion ? "textDisabled": "textPrimary"}
            variant={info.precioPromocion ? "body1" : "h4"}
            fontWeight="bold"
            component={info.precioPromocion ? "s" : "p"}
          >
            De: {info.precioLista}
          </Typography>
          {info.precioPromocion && <Typography variant="h4" fontWeight="bold">
            A: {info.precioPromocion}
          </Typography>}
          <Typography variant="body2" style={{textWrap: "wrap"}}>
            {info.duracionPrecioPromocion}
          </Typography>
     
         {info.comentario &&
         
          <Typography 
                 variant="body1"
                 
                 style={{textWrap: "wrap"}}>
            Precio {info.comentario}.
          </Typography>
           } 
           {info.clienteIzziPrecio && 
           <Typography 
                   variant="h6" 
                    style={{textWrap: "wrap"}}
                   
                     >
            {info.clienteIzziPrecio}
          </Typography>
          }
          {(info.promoPagoAnticipado !== "" && info.promoPagoAnticipado !== null ) && 
            <Typography variant="body2" style={{textWrap: "wrap"}}>
              {info.promoPagoAnticipado}
            </Typography>
          }
        </Box>
        <Box
          ml={2}
          mt={3}
          mb={isComplete ? 2 : 0}
          style={{ textWrap: "initial" }}
        >
          <Typography variant="body2">
            {info.promosPermanentes}
          </Typography>
          <Typography 
            color={info.appCanales ? "unset" : "textDisabled" }
            variant="body2"
          >
            {info.appCanales && isComplete
              ? info.appCanales
              : info.appCanales 
              ? `${info.appCanales.substring(0, 80)}${ info.appCanales.length > 80 ? '...' : ''}`
              : "No info"}
          </Typography>
        </Box>
        {hasSeeMore && (
          <Box mt={3} textAlign="right" mb={2}>
            <Button variant="text" color="secondary" onClick={handleSeeMore}>
              <Typography variant="body2" color="primary">
                Ver más
              </Typography>
            </Button>
          </Box>
        )}
      </StyledCardBody>
    </StyledCard>
  );
};

export default InfoCard;
